import { render, staticRenderFns } from "./StaticPlayerFilters.vue?vue&type=template&id=a56138c2&scoped=true"
import script from "./StaticPlayerFilters.js?vue&type=script&lang=js&external"
export * from "./StaticPlayerFilters.js?vue&type=script&lang=js&external"
import style0 from "./StaticPlayerFilters.vue?vue&type=style&index=0&id=a56138c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56138c2",
  null
  
)

export default component.exports